import { graphql } from '@/generated/gql';

export const INTAKE_BUDGET = graphql(/* GraphQL */ `
  query IntakeBudget($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        request {
          id
          budget
          currency
        }
        quote {
          id
          quotedValue
        }
      }
    }
  }
`);
